import React, { Component } from 'react'
import { Dropzone } from '../index'
import cx from 'classnames'
import { Feedback } from '@softwaredev_cegeka/stix-form'
import './fileUpload.scss'

class FileUpload extends Component {
    handleAcceptedFiles = files => {
        this.props.onReceivedFiles(files)
    }

    render() {
        const {
            label = 'File upload',
            allowedTypes,
            required,
            name,
            feedback,
            isValid,
            isInvalid,
            className,
        } = this.props

        let classes = cx(
            `stix-file-upload`,
            {
                [`stix-is-valid`]: isValid,
                [`stix-is-invalid`]: isInvalid,
            },
            className
        )
        return (
            <div className={classes}>
                <span className={'stix-form-label'}>
                    {label}
                    {required ? ' *' : null}
                </span>
                <Dropzone
                    onAcceptedFiles={this.handleAcceptedFiles}
                    formHandlesUpload
                    allowedMimeTypes={allowedTypes}
                    name={name}
                />
                {feedback ? (
                    <Feedback feedbackType={'invalid'} feedback={feedback} />
                ) : null}
            </div>
        )
    }
}

export default FileUpload
